import Vue from 'vue'
import { addGA } from '@/utils/assist'
import GemRemind from '@/components/gem-remind/gem-remind'
import BuyItems from '@/components/buy-items/buy-items'
const ERROR_KEYS = ['TOAST_EVENT_END', 'TOAST_GEM_NOT_ENOUGH', 'CHANGE_TOAST_1', 'CHANGE_TOAST_2']

export default new Vue({
  data() {
    return {
      uid: null,
      gems: 0,
      discount: 0,
      rules: '',
      discountEl: null, // 折扣模块div
      refreshable: true, // 是否可刷新
      drawing: false, // 抽取折扣中
      refreshing: false, // 刷新奖池中
      lang: 'en',
      discountRefreshInfo: {
        timesFree: 0,
        times: 0,
        limitsFree: 0,
        limits: 0,
        cost: 0
      },
      poolRefreshInfo: {
        timesFree: 0,
        times: 0,
        limitsFree: 0,
        limits: 0,
        cost: 0
      },
      reward: [],
      history: [],
      noRemind: false,
      transify: {
        CHANGE_BUY_CONFIRM_1: 'cost {gem num} to refresh the discount',
        CHANGE_BUY_CONFIRM_2: 'cost {gem num} to refresh the pool',
        CHANGE_BUY_ITEM: 'are you sure to buy',
        CHANGE_BUY_NOW: 'buy now',
        CHANGE_CHOOSE_PRICE: 'choose item {num/num}, discount price {gem num}',
        CHANGE_CONFIRM: 'confirm',
        CHANGE_DONE: 'done',
        CHANGE_FREE: 'free',
        CHANGE_HISTORY: 'history',
        CHANGE_NO_MORE_REMIND: "don't remind me again",
        CHANGE_OFF: 'off',
        CHANGE_POOL_REFRESH: 'pool refresh',
        CHANGE_RULE: 'rule',
        CHANGE_TITLE: 'change your fate',
        CHANGE_TOAST_1: 'All items have been displayed',
        CHANGE_TOAST_2: 'Refresh times have been used up',
        CHANGE_TOAST_3: 'Please select an item',
        CHANGE_TOAST_4: 'refresh the discount successfully',
        CHANGE_TOAST_5: 'refresh the pool successfully',
        CHANGE_TOAST_6: 'purchase done',
        CHANGE_TRY_YOUR_LUCK: 'try your luck',
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: '', // 需要默认值
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      }
    }
  },
  computed: {
    noRemindKey() {
      return `${this.uid}_${PROJECT_NAME}_noRemind`
    },
    isAr() {
      return this.lang === 'ar'
    }
  },
  components: {
    GemRemind,
    BuyItems
  },
  methods: {
    addGA,
    checkGem(price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError(data, closeable = true) {
      let code = typeof data === 'string' ? data : data.code
      closeable = typeof data === 'string' ? closeable : data.closeable
      this.addGA('msgError', code)
      let message =
        this.transify[code] || ((closeable = false), this.transify['TOAST_NETWORK_ERROR'])
      if (!ERROR_KEYS.includes(code)) closeable = false
      this.$toast.info({
        content: message,
        duration: closeable ? 2000 : 0
      })
    },
    // 普通提示信息
    handleToast(code) {
      let message = this.transify[code]
      this.$toast.info({
        content: message,
        duration: 2000,
        transition: { name: 'flipIn' }
      })
    },
    // 计算折扣后的价格
    countPrice(price) {
      return parseInt(((100 - this.discount) * price) / 100)
    },
    curRefreshTarget(type) {
      return this[type === 'discount' ? 'discountRefreshInfo' : 'poolRefreshInfo']
    },
    // 当前是否免费刷新
    // @params {type} discount | pool
    isFree(type) {
      let { timesFree, limitsFree } = this.curRefreshTarget(type)
      if (limitsFree - timesFree > 0) return true
      return false
    },
    // 当前是否不能再继续刷新
    isDone(type) {
      let { times, limits, timesFree, limitsFree } = this.curRefreshTarget(type)
      if (timesFree >= limitsFree && limits > -1 && times >= limits) return true
      return false
    },
    // 购买
    purchase(chosen) {
      this.addGA('purchaseButton', 'click')
      if (!this.refreshable) return this.handleToast('CHANGE_TOAST_1')
      if (chosen.length === 0) return this.handleToast('CHANGE_TOAST_3')

      const totalCost = chosen.reduce((acc, cur) => acc + cur.realCost, 0)
      if (!this.checkGem(totalCost)) return this.handleToast('TOAST_GEM_NOT_ENOUGH')

      const hasUniqueOwn = chosen.reduce((acc, cur) => acc || cur.unique_owned, false)
      const tipKey = hasUniqueOwn ? chosen.length === 1 ? 'UNIQUE_BUY_ALREADY_HAVE' : 'UNIQUE_BUY_ALREADY_HAVE_PART' : 'COMMON_TIPS_ITEM'
      // 出现购买弹窗
      this.$modal.info({
        tip: this.transify[tipKey],
        confirmTxt: this.transify['CHANGE_CONFIRM'],
        render: h =>
          h(BuyItems, {
            props: {
              list: chosen,
              title: this.transify['CHANGE_BUY_ITEM']
            }
          }),
        onConfirm: () => {
          // 确定购买
          const items = chosen.map(item => {
            return {
              index: item.index,
              cost: item.realCost
            }
          })
          this.$api.purchase({ items }).then(res => {
            this.handleToast('COMMON_TIPS_ITEM')
            this.gems -= totalCost
            this.history.unshift(...this.formatHistory(res.data.history))
            if (res.data.reward.length > 0) {
              // 必须先刷新 discount
              this.discount = res.data.discount
              this.discountEl.start()
              this.discountEl.stop(this.discount)
              this.reward = this.formatReward(res.data.reward)
              this.addGA('purchase', 'success')
            } else {
              // 无法继续购买
              this.refreshable = false
              items.forEach(item => {
                this.reward[item.index].checked = false
                this.reward[item.index].purchased = true
              })
            }
          }).catch(err => {
            console.log('purchase error...', err)
          })
        }
      })
    },
    // 刷新
    // @params {type} discount | pool
    refresh(type) {
      this.addGA(`${type}RefreshButton`, 'click')
      if (!this.refreshable) return this.handleToast('CHANGE_TOAST_1')
      if (this.isDone(type)) return this.handleToast('CHANGE_TOAST_2')

      const cost = this.isFree(type) ? 0 : this.curRefreshTarget(type).cost
      if (!this.checkGem(cost)) return this.handleToast('TOAST_GEM_NOT_ENOUGH')

      if (localStorage.getItem(this.noRemindKey) === 'true') {
        this[type === 'discount' ? 'discountRefresh' : 'poolRefresh'](cost)
      } else {
        this.noRemind = false // 再次进入必然是 false
        const confirmMsg = this.transify[
          type === 'discount' ? 'CHANGE_BUY_CONFIRM_1' : 'CHANGE_BUY_CONFIRM_2'
        ].replace('{gem num}', `<span class="gem">${cost || this.transify['CHANGE_FREE']}</span>`)
        // 出现扣钻弹窗
        this.$modal.info({
          confirmTxt: this.transify['CHANGE_CONFIRM'],
          render: h =>
            h(GemRemind, {
              props: {
                noRemind: this.noRemind,
                confirmMsg: confirmMsg,
                remindTxt: this.transify['CHANGE_NO_MORE_REMIND']
              },
              on: {
                check: () => {
                  this.noRemind = !this.noRemind
                }
              }
            }),
          onConfirm: () => {
            localStorage.setItem(this.noRemindKey, this.noRemind + '')
            this[type === 'discount' ? 'discountRefresh' : 'poolRefresh'](cost)
          }
        })
      }
    },
    // 刷新折扣
    discountRefresh(cost) {
      this.discountEl.start().then(_ => {
        this.$api.refreshDiscount({ cost }).then(res => {
          this.discount = res.data.discount
          this.discountEl.stop(this.discount).then(_ => {
            this.gems -= cost
            this.handleToast('CHANGE_TOAST_4')
            this.history.unshift(res.data.history[0])
            this.reward.forEach(item => item.realCost = this.countPrice(item.cost))
            this.isFree('discount') ? this.discountRefreshInfo.timesFree++ : this.discountRefreshInfo.times++
            this.addGA('refreshDiscount', 'success')
          })
        }).catch(err => {
          let discount = NaN
          if (ERROR_KEYS.includes(err.code)) {
            discount = this.discount
          }
          this.discountEl.abortRollAbruptly(discount)
          console.log('discount refresh error...', err)
        })
      })
    },
    // 刷新奖池
    poolRefresh(cost) {
      this.refreshing = true
      this.$api.refreshPool({ cost }).then(res => {
        if (res.data.reward.length > 0) {
          // NOTE 这种情况必现
          this.gems -= cost
          this.handleToast('CHANGE_TOAST_5')
          this.history.unshift(res.data.history[0])
          this.reward = this.formatReward(res.data.reward)
          this.isFree('pool') ? this.poolRefreshInfo.timesFree++ : this.poolRefreshInfo.times++
          this.addGA('refreshPool', 'success')
        } else {
          // 不能再刷新（刷新失败）
          this.handleToast('CHANGE_TOAST_1')
          this.refreshable = false
        }
        this.refreshing = false
      })
        .catch(err => {
          this.refreshing = false
          console.log('pool refresh error...', err)
        })
    },
    formatReward(data) {
      return data.map((item, index) => {
        return {
          ...item,
          index: index, // 商品索引
          realCost: this.countPrice(item.cost), // 现价
          purchased: item.purchased, // 是否已购买
          checked: false // 是否已选择
        }
      })
    },
    formatHistory(data) {
      return data.sort((a, b) => b.created_at - a.created_at)
    },
    formatData(item) {
      return {
        image: item.item_img,
        num: item.item_num,
        rarity: item.rarity,
        showCheck: false
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js